import { type ReactNode } from 'react';

import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export function InviteClientHeader({
  title,
  description,
  isOptional,
  action,
}: {
  title: ReactNode;
  description: ReactNode;
  isOptional?: boolean;
  action?: ReactNode;
}) {
  return (
    <DialogHeader>
      <div className="flex items-center justify-between gap-4">
        <DialogTitle className="flex items-center gap-2 text-lg font-semibold text-gray-950">
          {title}
          {isOptional && (
            <span className="rounded-full bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-700">
              Optional
            </span>
          )}
        </DialogTitle>
        {action}
      </div>
      <DialogDescription className="text-balance text-start text-gray-700">
        {description}
      </DialogDescription>
    </DialogHeader>
  );
}
